// Helpers for incident formatting / classification

export const TYPE_GROUPS = {
  WILDFIRE: ["Wildfire", "Wildland", "Wildland Fire", "Fire"],
  PRESCRIBED: ["Prescribed Fire", "Prescribed", "Rx"],
  SMOKE: ["Smoke Check", "Smoke Investigation", "Smoke"],
  MEDICAL: ["Medical", "Medical Aid"],
  OTHER: [],
};

export function classifyType(type = "") {
  const t = type.toLowerCase();
  if (t.includes("wildfire") || t.includes("wildland")) return "WILDFIRE";
  if (t.includes("prescribed") || t.includes("rx")) return "PRESCRIBED";
  if (t.includes("smoke")) return "SMOKE";
  if (t.includes("medical")) return "MEDICAL";
  return "OTHER";
}

export const TYPE_META = {
  WILDFIRE: { label: "Wildfire", color: "#F2542D", textOn: "#fff" },
  PRESCRIBED: { label: "Prescribed Burn", color: "#457B9D", textOn: "#fff" },
  SMOKE: { label: "Smoke Check", color: "#FFB347", textOn: "#0A0D0C" },
  MEDICAL: { label: "Medical", color: "#2A9D8F", textOn: "#fff" },
  OTHER: { label: "Other", color: "#94A39A", textOn: "#0A0D0C" },
};

export const STATUS_META = {
  ACTIVE: { label: "ACTIVE", color: "#E63946", bg: "rgba(230,57,70,0.15)", border: "rgba(230,57,70,0.5)" },
  CONTAINED: { label: "CONTAINED", color: "#FFB347", bg: "rgba(255,179,71,0.15)", border: "rgba(255,179,71,0.5)" },
  CONTROLLED: { label: "CONTROLLED", color: "#2A9D8F", bg: "rgba(42,157,143,0.15)", border: "rgba(42,157,143,0.5)" },
  OUT: { label: "OUT", color: "#94A39A", bg: "rgba(148,163,154,0.15)", border: "rgba(148,163,154,0.4)" },
};

export function formatAcres(a) {
  if (a == null || a === "" || a === "null") return "—";
  const n = Number(a);
  if (Number.isNaN(n)) return a;
  if (n < 1) return n.toFixed(2);
  if (n < 10) return n.toFixed(1);
  return Math.round(n).toLocaleString();
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString("en-US", {
      month: "short", day: "numeric", year: "numeric",
      hour: "numeric", minute: "2-digit", hour12: false,
    });
  } catch { return iso; }
}

export function relTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso).getTime();
    if (Number.isNaN(d)) return "—";
    const diff = Date.now() - d;
    const min = Math.round(diff / 60000);
    if (min < 1) return "just now";
    if (min < 60) return `${min}m ago`;
    const h = Math.round(min / 60);
    if (h < 24) return `${h}h ago`;
    const days = Math.round(h / 24);
    if (days < 30) return `${days}d ago`;
    const months = Math.round(days / 30);
    return `${months}mo ago`;
  } catch { return "—"; }
}
